import React from 'react';
import { Modal, Row, Col, Container, Button } from 'react-bootstrap';
import './FilterModal.scss';
import PrimaryButton from '../button';
import GenericButton from '../button/GenericButton/GenericButton';
import { BackAvatarSVG } from '../../../img/GlobalSVG';
import { CLIENT_TYPES } from 'src/constants';
import { useSelector } from 'react-redux';

const FilterModal = ({
  showTitle = true,
  titleLabel = 'FILTERS',
  showClearFilter = false,
  showClearFilterLabel = 'RESET FILTER',
  showCancel = true,
  showCancelLabel = 'Cancel',
  showApply = true,
  showApplyLabel = 'Apply',
  showBackButton = true,
  showBackButtonMobile = true,
  applyFilterHandler,
  isVisible,
  customClasses,
  onHide,
  resetFilter,
  isDisabled = false,
  postLabel = '',
  ...otherProps
}) => {
  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  return (
    <span
      onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <Modal
        show={isVisible}
        onHide={onHide}
        className={`Right-Model generic-model-admin ${customClasses}`}
      >
        <Modal.Header closeButton>
          <Container className="px-0">
            <Row className="align-items-center p-0 m-0">
              {(showBackButton || (showBackButtonMobile && isMobileClient)) && (
                <Col className="px-0">
                  <Button
                    onClick={onHide}
                    className="back-arrow cursor-pointer d-inline"
                    variant="link"
                  >
                    <BackAvatarSVG.BackArrowSVG />
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="align-items-center p-0 m-0">
              <Col className="px-0">
                <Modal.Title>{titleLabel}</Modal.Title>
              </Col>
              {showClearFilter && (
                <Col>
                  <PrimaryButton
                    onClick={resetFilter}
                    className="height-32 reset-filter-button"
                    variant="secondary"
                  >
                    {showClearFilterLabel}
                  </PrimaryButton>
                </Col>
              )}
            </Row>
          </Container>
        </Modal.Header>
        <Modal.Body>
          <Container className="px-0 custom-scroller modal-content-container">
            {otherProps.children}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <div className="model-footer-btn txt-right p-0 m-0 border-0">
            {showCancel && (
              <button
                type="button"
                className="btn btn-link mr-2"
                onClick={onHide}
              >
                {showCancelLabel}
              </button>
            )}

            {showApply && (
              <GenericButton
                disable={isDisabled}
                onClick={applyFilterHandler}
                variant="primary"
                postLabel={postLabel}
              >
                {showApplyLabel}
              </GenericButton>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </span>
  );
};

export default FilterModal;
